import { ADD_ADVERT } from 'shared/constants/links';
import type { TBanner } from 'shared/types/banner';

export const SMB_PRE_FOOTER_BANNER: TBanner = {
  title: 'Начать работать с Циан',
  linkBtn: {
    url: ADD_ADVERT,
    text: 'Разместить объявление',
  },
  imageClass: 'smb-pre-footer',
};
